interface QuickStatsProps {
  entryCount: number
  symptomCount: number
  mealCount: number
}

export function QuickStats({
  entryCount,
  symptomCount,
  mealCount,
}: QuickStatsProps) {
  return (
    <div className="insight-card flex items-center justify-center gap-4 py-2">
      <span
        style={{
          fontSize: 11,
          fontWeight: 500,
          color: "var(--fig-text-placeholder)",
        }}
      >
        {entryCount} {entryCount === 1 ? "entry" : "entries"}
      </span>
      <span style={{ fontSize: 11, color: "var(--fig-text-placeholder)" }}>
        &middot;
      </span>
      <span
        style={{
          fontSize: 11,
          fontWeight: 500,
          color: "var(--fig-text-placeholder)",
        }}
      >
        {symptomCount} symptom{symptomCount !== 1 ? "s" : ""}
      </span>
      <span style={{ fontSize: 11, color: "var(--fig-text-placeholder)" }}>
        &middot;
      </span>
      <span
        style={{
          fontSize: 11,
          fontWeight: 500,
          color: "var(--fig-text-placeholder)",
        }}
      >
        {mealCount} meal{mealCount !== 1 ? "s" : ""}
      </span>
    </div>
  )
}
